import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

interface LimitWarningProps {
  used: number;
  limit: number;
}

export function LimitWarning({ used, limit }: LimitWarningProps) {
  const { t } = useLanguage();

  // Don't show if not at limit or limit is infinite
  if (used < limit || limit === Infinity) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3 animate-fade-in">
      <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
        <AlertCircle className="w-5 h-5 text-amber-600" />
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium text-amber-800">
          {t('watchlist.limitReached.title', 'Watchlist limit reached')}
        </p>
        <p className="text-sm text-amber-700 mt-1">
          {t('watchlist.limitReached.message', 'Upgrade to Pro for more watchlist slots or remove items to add new ones.')}
        </p>
        <Link
          to="/account/subscription"
          className="inline-flex items-center mt-2 text-sm font-semibold text-amber-800 hover:text-amber-900 underline underline-offset-2"
        >
          {t('watchlist.limitReached.upgrade', 'Upgrade now')}
        </Link>
      </div>
    </div>
  );
}
